







import * as _ from 'lodash'
import { Component, Vue } from 'vue-property-decorator'
import { AUTHORIZE } from '@/store/modules/app/keys'

@Component
export default class Authorize extends Vue {
  // 处理登录操作
  async handleAuthorize (approve: boolean) {
    try {
      const response = await this.$store.dispatch(AUTHORIZE, approve)
      window.location.href = _.get(response, 'headers.location')
    } catch (error) {
      alert(error.message)
    }
  }
}
